export default __webpack_public_path__ + "static/media/phone.41931ef3.svg";